<template>
  <v-app>
    <v-main style="position: relative">
      <v-app-bar
        v-if="!showPrivacyPolicy"
        app
        elevation="0"
        :style="`background: ${appBarColor}; ${$vuetify.breakpoint.smAndDown ? 'height: 61px !important;' : 'height: 65px !important;'}`"
      >
        <div class="d-flex flex-column flex-grow-1">
          <div class="d-flex flex-grow-1">
            <div class="mx-5 my-3 d-flex justify-center align-center">
              <img
                width="200"
                src="../public/colorFull.svg"
                alt="Logo"
              />
            </div> <!-- Logo -->
            <div v-if="$vuetify.breakpoint.mdAndUp" class="ml-5 mr-10 flex-grow-1 d-flex justify-end">
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    target="_blank"
                    @click="showPrivacyPolicy = !showPrivacyPolicy"
                  >Privacy Policy</v-btn>
                  <div :class="`ml-2 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover> <!-- Privacy Policy Btn -->
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    href="#Features"
                  >Features</v-btn>
                  <div :class="`ml-2 mt-1 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover> <!-- Helpful Features Btn -->
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    href="#Integration"
                  >Integration</v-btn>
                  <div :class="`ml-2 mt-1 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover> <!-- Tasklogix Integration Btn -->
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    href="#Providers"
                  >Providers</v-btn>
                  <div :class="`ml-2 mt-1 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover>  <!-- Providers We Offer Btn -->
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    href="#Pricing"
                  >Pricing</v-btn>
                  <div :class="`ml-2 mt-1 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover> <!-- Pricing Btn -->
              <v-hover #default="{ hover }">
                <div :class="`mr-2 d-flex flex-column justify-center ${hover ? '' : 'align-end'}`">
                  <v-btn
                    text
                    small
                    rounded
                    color="#375E97"
                    target="_blank"
                    href="https://med.Tasklogix.co.za/app"
                  >Login</v-btn>
                  <div :class="`ml-2 mt-1 ${hover ? 'animationLeftToRight' : 'animationRightToLeft' }`"></div>
                </div>
              </v-hover> <!-- Login Btn -->
            </div> <!-- App Bar Btn -->
            <div v-else class="flex-grow-1 d-flex justify-end">
              <v-menu
                bottom
                offset-y
                close-on-content-click
                close-on-click
              >
                <template #activator="{ attrs, on }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    fab
                    text
                    elevation="0"
                  >
                    <v-icon large color="black">mdi-menu</v-icon>
                  </v-btn>
                </template> <!-- Burger Icon -->
                <div style="background-color: #FFFFFF">
                  <div class="mr-2 d-flex justify-center align-center">
                    <v-btn
                      text
                      small
                      rounded
                      color="#375E97"
                      target="_blank"
                      @click="showPrivacyPolicy = !showPrivacyPolicy"
                    >Privacy Policy</v-btn>
                  </div> <!-- Privacy Policy Btn -->
                  <div class="mr-2 d-flex justify-center align-center">
                    <v-btn
                      text
                      small
                      rounded
                      color="#375E97"
                      href="#Features"
                    >Features</v-btn>
                  </div> <!-- Helpful Features Btn -->
                  <div class="mr-2 d-flex justify-center align-center">
                    <v-btn
                      text
                      small
                      rounded
                      color="#375E97"
                      href="#Integration"
                    >Integration</v-btn>
                  </div> <!-- Tasklogix Integration Btn -->
                  <div class="mr-2 d-flex justify-center align-center">
                    <v-btn
                      text
                      small
                      rounded
                      color="#375E97"
                      href="#Pricing"
                    >Pricing</v-btn>
                  </div> <!-- Pricing Btn -->
                  <div class="d-flex justify-center align-center">
                    <v-btn
                      text
                      small
                      rounded
                      color="#375E97"
                      target="_blank"
                      href="https://med.Tasklogix.co.za/app"
                    >Login</v-btn>
                  </div> <!-- Login Btn -->
                </div> <!-- Btn -->
              </v-menu>
            </div> <!-- App Bar Btn Small Screens -->
          </div> <!-- App Bar Title -->
        </div> <!-- App Bar Content -->
      </v-app-bar>
      <v-sheet v-if="!showPrivacyPolicy" class="overflow-y-auto">
        <div style="position: relative">
          <div :class="`mb-16 d-flex flex-shrink-0 ${$vuetify.breakpoint.smAndDown ? 'flex-column' : ''}`">
            <div
              class="flex-grow-1 d-flex flex-equal flex-column ma-7"
              :style="`${$vuetify.breakpoint.smAndDown ? 'padding-left: 5%' : 'padding-left: 11%'}`"
            >
              <div class="d-flex flex-column">
                <div class="text-h1 mb-3">Create</div>
                <div class="text-h3 mb-3 pb-2 d-flex align-end">Medical Quotes</div>
              </div> <!-- Create Medical Quotes -->
              <div class="text-h2 d-flex flex-column">
                <div class="gradiantText mb-1">Easy,</div>
                <div class="gradiantText">Simple,</div>
                <div class="gradiantText">Hassle Free</div>
              </div> <!-- Easy, Simple, Hassle Free -->
              <div
                class="d-flex flex-column flex-grow-1 mt-3 body-2"
                :style="`${$vuetify.breakpoint.mdAndDown ? '' : 'width: 500px'}`"
              >
                <div style="background-color: #FFFFFF">
                  Are you tired of spending hours searching for the best medical insurance quotes for your clients? Do you want to simplify the process and save time?
                </div>
                <div class="mt-2" style="background-color: #FFFFFF">
                  Medlogix is for any Medical Broker who wants an Easy, Simple and Hassle Free way to generate quotes for their clients.
                </div>
              </div>
            </div> <!-- Text -->
            <div
              class="flex-grow-1 flex-equal d-flex justify-center align-center"
              :style="`${$vuetify.breakpoint.smAndDown ? 'padding: 3%' : 'padding-right: 11%'}`"
            >
              <v-img
                :width="`${$vuetify.breakpoint.lgAndDown ? '500' : '700'}`"
                :height="`${$vuetify.breakpoint.lgAndDown ? '400' : '450'}`"
                alt="Landing Page Image"
                src="../screenshots/Landing_Page.svg"
                style="border-radius: 40px"
              ></v-img>
            </div> <!-- Landing Page Image -->
          </div> <!-- Front Page -->
          <div :class="`d-flex flex-column ${$vuetify.breakpoint.xs ? 'mt-7' : ''}`">
            <div :class="`px-5 my-16 flex-grow-1 flex-equal d-flex flex-column justify-center align-center`">
              <div
                class="flex-column mb-3 mt-16 body-1 d-flex"
                style="width: 80%"
                v-for="(item, i) in whatWeDo"
                :key="i"
              >
                <div :class="`d-flex ${$vuetify.breakpoint.smAndDown ? 'flex-column' : ''}`">
                  <div
                    v-if="$vuetify.breakpoint.smAndDown || item.imagePosition === 'left'"
                    class="mb-5 flex-grow-1 flex-equal d-flex justify-center align-center"
                  >
                    <div style="border-radius: 40px" class="elevation-5">
                      <v-img
                        alt="Banner"
                        :src="item.image"
                        :width="`${$vuetify.breakpoint.smAndDown ? '80vw' : '30vw'}`"
                        :height="`${$vuetify.breakpoint.smAndDown ? '30vh' : '40vh'}`"
                        style="border-radius: 40px"
                      ></v-img>
                    </div>
                  </div> <!-- Image Left -->
                  <div v-if="!$vuetify.breakpoint.smAndDown && item.imagePosition === 'left'">
                    <v-divider vertical></v-divider>
                  </div> <!-- divider -->
                  <div class="flex-grow-1 flex-equal d-flex justify-center align-center">
                    <div
                      class="d-flex flex-column justify-center align-center"
                      :style="`${$vuetify.breakpoint.smAndDown ? '' : 'width: 60vh; height: 40vh'}`"
                    >
                      <div
                        class="text-h3 pb-5 gradiantText font-weight-light"
                        :class="$vuetify.breakpoint.smAndDown ? 'text-center' :
                                                    `${item.imagePosition === 'left' ? 'text-left' : 'text-right'}`"
                        style="width: 100%"
                      >{{ item.title }}</div> <!-- Title -->
                      <div
                        class="body-1 d-flex"
                        :class="$vuetify.breakpoint.smAndDown ? 'align-center justify-center' :
                                                    `${item.imagePosition === 'left' ? 'text-left' : 'text-right'}`"
                      >{{ item.body }}</div> <!-- Body -->
                    </div>
                  </div> <!-- Paragraph -->
                  <div v-if="!$vuetify.breakpoint.smAndDown && item.imagePosition === 'right'">
                    <v-divider vertical></v-divider>
                  </div> <!-- divider -->
                  <div
                    v-if="!$vuetify.breakpoint.smAndDown && item.imagePosition === 'right'"
                    class="flex-grow-1 flex-equal d-flex justify-center align-center"
                  >
                    <div style="border-radius: 40px" class="elevation-5">
                      <v-img
                        alt="Banner"
                        :src="item.image"
                        :width="`${$vuetify.breakpoint.smAndDown ? '80vw' : '30vw'}`"
                        :height="`${$vuetify.breakpoint.smAndDown ? '30vh' : '40vh'}`"
                        style="border-radius: 40px"
                      ></v-img>
                    </div>
                  </div> <!-- Image Right -->
                </div> <!-- content -->
                <div v-if="!$vuetify.breakpoint.smAndDown" class="ma-16">
                  <v-divider></v-divider>
                </div> <!-- divider -->
              </div> <!-- Paragraph -->
              <div id="Features"></div>
            </div> <!-- What We Do -->
            <div class="d-flex flex-column" style="width: 100%">
              <div style="width: 100%">
                <div class="d-flex flex-column align-end" style="margin-bottom: -1px">
                  <img
                    src="../screenshots/curve_flat-01.svg"
                    alt="Curved Image"
                    class="pb-0 mb-0"
                    style="object-fit: fill; margin: 0; padding: 0; background-position: bottom"
                    width="100%"
                  >
                </div> <!-- Curve Image -->
                <div style="background: linear-gradient(90deg, #375e97 0%, #528de3 100%);" class="pb-6">
                  <div class="text-h4 d-flex flex-column justify-center align-center py-3">
                    <div style="position: relative">
                      <div style="position: relative" class="white--text">Key Features</div>
                      <div style="position: absolute; width: 160px; height: 7px; top: 35px; left: 50px; border-top: solid 5px #fb6542; border-right: solid 4px transparent; border-left: solid 4px transparent; border-radius: 75%/10px 10px 0 0"></div>
                    </div>
                  </div> <!-- Title -->
                  <div class="d-flex flex-wrap justify-center align-center">
                    <div class="pa-7" style="width: 500px" v-for="(feature, i) in features" :key="i">
                      <div class="pa-2 d-flex align-center">
                        <div style="background: #FFFFFF10; border-radius: 50%" class="pa-4">
                          <v-icon x-large class="white--text">{{feature.icon}}</v-icon>
                        </div>
                        <div class="flex-grow-1 white--text text-h4 pl-6">{{feature.title}}</div>
                      </div>
                      <div class="pa-2 white--text text-subtitle-1 text-center">{{feature.body}}</div>
                    </div>
                  </div> <!-- Body -->
                </div> <!-- Content -->
              </div>
              <div id="Integration"></div>
            </div> <!-- Key Features -->
            <div
              class="px-5 d-flex flex-column"
              :class="$vuetify.breakpoint.mdAndDown ? 'mb-16' : 'my-16'"
              style="position: relative; height: 400px"
            >
              <div
                v-if="!$vuetify.breakpoint.mdAndDown"
                class="gear-div"
                style="position: absolute; left: 2%; top: -100px"
              >
                <div class="small-gear-div">
                  <img alt="gears" class="small-gear" src="../screenshots/cog.svg">
                  <img alt="gears" class="gear-logo" src="../screenshots/globe_light.svg">
                </div>
                <div class="big-gear-div">
                  <img alt="gears" class="gear" src="../screenshots/cog.svg">
                  <img alt="gears" class="gear-logo" src="../screenshots/med.svg">
                </div>
              </div> <!-- Gears -->
              <div
                class="d-flex flex-column justify-center align-end flex-grow-1"
                :style="$vuetify.breakpoint.mdAndDown ? 'width: 100%' : ''"
              >
                <div :style="`${$vuetify.breakpoint.mdAndDown ? 'width: 100%' : 'width: 50%; position: absolute; right: 10%'}`">
                  <div class="text-h3 d-flex flex-column text-center justify-center align-center mb-5">
                    <div style="position: relative">
                      <div style="position: relative">Tasklogix Integration</div>
                      <div style="position: absolute; width: 275px; height: 7px; top: 55px; left: 190px; border-top: solid 5px #fb6542; border-right: solid 4px transparent; border-left: solid 4px transparent; border-radius: 75%/10px 10px 0 0"></div>
                    </div>
                  </div> <!-- Title -->
                  <div class="d-flex flex-column justify-center align-center text-center body-1">
                    <div style="background-color: #FFFFFF">
                      By utilizing Medlogix, you can effortlessly link it to Tasklogix. This seamless integration enables the automatic
                      linking of quotes to a specific task, streamlining your workflow and reducing the time and effort required to complete tasks.
                      Alternatively, we can simply send the quote directly to your email address.
                    </div> <!-- Text -->
                    <div class="body-2" style="background-color: #FFFFFF">
                      For more information about Tasklogix, <a class="secondary--text" target="_blank" href="https://www.Tasklogix.co.za/">click here.</a>
                    </div> <!-- For More Info -->
                  </div> <!-- Body -->
                </div>
              </div> <!-- Tasklogix Integration -->
              <div id="Providers"></div>
            </div> <!-- Tasklogix Integration -->

            <div class="my-16 d-flex flex-column justify-center align-center" style="width: 100%">

              <div class="text-h3 d-flex flex-column text-center justify-center align-center mb-5">
                <div style="position: relative">
                  <div style="position: relative">Providers We Offer</div>
                  <div style="position: absolute; width: 165px; height: 7px; top: 55px; left: 265px; border-top: solid 5px #fb6542; border-right: solid 4px transparent; border-left: solid 4px transparent; border-radius: 75%/10px 10px 0 0"></div>
                </div>
              </div> <!-- Title -->

              <div
                class="d-flex pt-5"
                :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : null"
                style="width: 70%"
              >

                <div
                  v-for="(value, key, k) in providersWeOfferArr"
                  :key="key + 'A'"
                  class="flex-grow-1 d-flex flex-column align-center"
                >

                  <div class="text-h5">{{ key }}</div>

                  <div
                    v-for="(item, i) in value"
                    :key="i + 'A'"
                    class="d-flex py-3"
                    :class="i % 2 ? 'justify-end' : null"
                    :style="`width: ${$vuetify.breakpoint.smAndDown ? '100' : '80'}%`"
                  >
                    <v-card
                      flat
                      style="height: 60px"
                      :style="`border: 1px solid ${k === 0 ? (i % 2 ? '#FFBB00' : '#FB6542') : (i % 2 ? '#FB6542' : '#FFBB00')}; width: ${$vuetify.breakpoint.smAndDown ? '100' : '80'}%`"
                    >
                      <div class="d-flex">
                        <div
                          :class="`${k === 0 ? (i % 2 ? 'primary' : 'accent') : (i % 2 ? 'accent' : 'primary')}`"
                          style="width: 5px; height: 60px; border-bottom-left-radius: 20px; border-top-left-radius: 20px"
                        ></div>
                        <v-card-title class="font-weight-regular">{{ item }}</v-card-title>
                      </div>
                    </v-card>
                  </div>
                </div>

              </div>

              <div
                class="text-h6 mt-3 font-weight-black d-flex justify-center align-end"
                style="width: 80%"
              >Additional providers will be charged at&nbsp;<div class="text-h5 font-weight-medium">R180</div>&nbsp;per provider, per month</div>
              <div id="Pricing"></div>



            </div> <!-- Providers that we cover -->

            <div
              :class="`flex-grow-1 d-flex ${$vuetify.breakpoint.mdAndDown ? 'flex-column' : ''}`"
              style="position: relative"
            >
              <div class="flex-grow-1 black">
                <v-img
                  alt="Banner"
                  src="../screenshots/Banner.svg"
                  :height="`${$vuetify.breakpoint.mdAndDown ? '880' : '450'}`"
                  style="opacity: 40%"
                ></v-img>
<!--                :height="`${$vuetify.breakpoint.mdAndDown ? '780' : '350'}`"-->
              </div> <!-- Banner Image -->
              <div
                class="white--text mt-8 full-height d-flex flex-column"
                :style="`position: absolute; ${$vuetify.breakpoint.mdAndDown ? 'top: 0; width: 100%' : 'top: 0; width: 60%'}`"
              >
                <div class="text-h4 d-flex flex-column justify-center align-center">
                  <div style="position: relative">
                    <div style="position: relative">Pricing</div>
                    <div style="position: absolute; width: 130px; height: 7px; top: 40px; left: -10px; border-top: solid 5px #fb6542; border-right: solid 4px transparent; border-left: solid 4px transparent; border-radius: 75%/10px 10px 0 0"></div>
                  </div>
                </div> <!-- Title -->
                <div class="d-flex flex-column body-1 align-center justify-center">
                  <div class="d-flex flex-column" style="width: 100%">
                    <div class="text-h6 mb-3 mt-8 font-weight-black d-flex justify-center align-center">&nbsp;<div class="text-h5 font-weight-medium">R250</div>&nbsp; per User</div>

                    <div class="d-flex flex-column justify-center align-center pb-3 text-h6">
                      <div>Once-Off Implementation Fee</div>
                      <div>R200 per User - Min R1 000</div>
                      <div>* All prices are Exclusive of VAT</div>
                    </div>

                    <div class="mb-5 text-h6 d-flex justify-center align-center">What this package Includes</div>
                    <div :class="`mb-4 body-1 d-flex ${$vuetify.breakpoint.mdAndDown ? 'flex-column' : 'justify-center align-center'}`">
                      <div v-if="!$vuetify.breakpoint.mdAndDown" class="d-flex">
                        <div class="ml-10 py-5">
                          <v-icon color="white">mdi-circle-small</v-icon>
                          Unlimited Clients
                        </div> <!-- Unlimited Clients -->
                        <div class="ml-10 py-5">
                          <v-icon color="white">mdi-circle-small</v-icon>
                          Unlimited Quotes
                        </div> <!-- Unlimited Quotes -->
                        <div class="ml-10 py-5">
                          <v-icon color="white">mdi-circle-small</v-icon>
                          Unlimited Documents
                        </div> <!-- Unlimited Documents -->
                        <div class="ml-10 py-5">
                          <v-icon color="white">mdi-circle-small</v-icon>
                          Tasklogix Mail Integration
                        </div> <!-- Tasklogix Mail Integration -->
                      </div> <!-- Products on medium to extra large screens -->
                      <div v-else class="d-flex mx-2">
                        <div class="flex-grow-1 flex-equal d-flex flex-column justify-center align-center">
                          <div class="py-5 text-center">
                            <v-icon color="white">mdi-circle-small</v-icon>
                            Unlimited Clients
                          </div> <!-- Unlimited Clients -->
                          <div class="py-5 text-center">
                            <v-icon color="white">mdi-circle-small</v-icon>
                            Unlimited Quotes
                          </div> <!-- Unlimited Quotes -->
                        </div>
                        <div class="flex-grow-1 flex-equal d-flex flex-column">
                          <div class="py-5 text-center">
                            <v-icon color="white">mdi-circle-small</v-icon>
                            Unlimited Documents
                          </div> <!-- Unlimited Documents -->
                          <div class="py-5 text-center">
                            <v-icon color="white">mdi-circle-small</v-icon>
                            Tasklogix Mail Integration
                          </div> <!-- Tasklogix Mail Integration -->
                        </div>
                      </div> <!-- Products on small to extra small screens -->
                    </div> <!-- Package Includes -->
                  </div> <!-- What it includes -->
                  <v-divider style="width: 75%"></v-divider>
                  <div class="mt-4 body-1 text-center">Get Medlogix today and start simplifying your quotes!</div>
                </div> <!-- Body -->
              </div> <!-- Pricing -->
              <div
                class="mt-8"
                :style="`position: absolute; ${$vuetify.breakpoint.mdAndDown ? 'top: 55%; width: 100%' : 'top: 0; left: 60%'}`"
              >
                <div
                  class="white--text flex-grow-1 d-flex flex-column justify-center align-center pa-3"
                  :style="`border-radius: 20px; ${$vuetify.breakpoint.mdAndDown ? 'width: 100%' : ''}`"
                >
                  <div class="text-h4 d-flex flex-column justify-center align-center mb-5">
                    <div style="position: relative">
                      <div style="position: relative">Ready to Start?</div>
                      <div style="position: absolute; width: 113px; height: 7px; top: 35px; left: 123px; border-top: solid 5px #fb6542; border-right: solid 4px transparent; border-left: solid 4px transparent; border-radius: 75%/10px 10px 0 0"></div>
                    </div>
                  </div> <!-- Title -->
                  <div class="d-flex justify-center align-center font-weight-bold">Contact us today to get started!</div> <!-- Text -->
                  <div
                    class="d-flex flex-column"
                    :style="`${$vuetify.breakpoint.xsOnly ? 'width: 100%' : 'width: 450px'}`"
                  >
                    <div>
                      <v-form ref="contact" @submit.stop.prevent>
                        <v-text-field
                          dark
                          dense
                          outlined
                          hide-details
                          class="my-2"
                          color="#FFBB00"
                          placeholder="Name and Surname"
                          prepend-icon="mdi-account"
                          v-model="name"
                          :rules="[validationRules.required]"
                        ></v-text-field> <!-- Name and Surname -->
                        <v-text-field
                          dark
                          dense
                          outlined
                          hide-details
                          class="my-2"
                          color="#FFBB00"
                          placeholder="Email"
                          prepend-icon="mdi-mail"
                          v-model="email"
                          :rules="[validationRules.required, validationRules.email]"
                        ></v-text-field> <!-- Email -->
                        <v-textarea
                          dark
                          dense
                          outlined
                          :rows="2"
                          hide-details
                          class="my-2"
                          color="#FFBB00"
                          placeholder="Message"
                          prepend-icon="mdi-message"
                          v-model="message"
                          :rules="[validationRules.required]"
                        ></v-textarea> <!-- Message -->
                      </v-form>
                    </div> <!-- Input fields -->
                    <div class="py-2 pt-1 d-flex justify-end">
                      <v-btn
                        dark
                        small
                        outlined
                        @click="sendMessage"
                        :loading="sendingMail"
                        :disabled="sendingMail"
                      >Send Message</v-btn>
                    </div> <!-- Send Message Btn -->
                  </div> <!-- Ready to Start -->
                </div> <!-- Contact Us -->
              </div> <!-- Ready to Start -->
            </div> <!-- Pricing Banner -->
          </div> <!-- Body -->
          <div
            :class="`py-5 white--text d-flex ${$vuetify.breakpoint.xs ? 'flex-column' : ''}`"
            style="background-color: #375e97"
          >
            <div :class="`pr-5 flex-grow-1 d-flex align-center ${$vuetify.breakpoint.xs ? 'justify-center' : 'justify-end'}`">
              <div class="mx-5 d-flex justify-center align-center">
                <img width="200" src="../public/whiteFull.svg" alt="Logo"/>
              </div> <!-- Logo -->
            </div> <!-- Logo -->
            <div :class="`flex-grow-1 d-flex flex-column caption justify-center ${$vuetify.breakpoint.xs ? 'align-center mt-3' : ''}`">
              <div class="d-flex">
                <v-icon dark small>mdi-phone</v-icon>
                <div class="ml-3">Support Telephone:&nbsp;</div>
                <div>+27 15 000 6133</div>
              </div> <!-- Contact Phone -->
              <div class="d-flex">
                <v-icon dark small>mdi-email-outline</v-icon>
                <div class="ml-3">Support Email:&nbsp;</div>
                <div>msupport@Tasklogix.co.za</div>
              </div> <!-- Contact Email -->
            </div> <!-- Contact Detail -->
          </div> <!-- Footer -->
          <div class="py-2 body-2 white--text d-flex justify-center align-center" style="background-color: #375E97">
            Copyright Tasklogix (Pty) Ltd {{ new Date().getFullYear() }}
          </div> <!-- Copyright Text -->
        </div> <!-- Body -->
      </v-sheet> <!-- Website Content -->

      <privacy_-policy
        v-if="showPrivacyPolicy"
        :privacyPolicy.sync="showPrivacyPolicy"
      ></privacy_-policy>

    </v-main>
  </v-app>

</template>

<script>

import Privacy_Policy from "@/components/Privacy_Policy";
export default {
  components: {Privacy_Policy},
  data() {
    return {
      console,

      showPrivacyPolicy: false,
      appBarColor: null,
      name: null,
      email: null,
      message: null,
      validationRules: {
        required: value => !!value || 'Required Value',
        email: value => {
          if (value && value !== null && value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'Invalid Email Address';
          } else {
            return 'Please enter a valid email address';
          }
        },
      },
      sendingMail: false,
      features: [
        {
          icon: "mdi-animation-outline",
          title: "Generate Quotes",
          body: "Medlogix allows brokers to customize quotes according to their client's specific needs and preferences by allowing them to generate up to 3 different quotes.",
        },
        {
          icon: "mdi-account-check",
          title: "Broker Recommendation",
          body: "Easily give your Recommendation and have it reflect on the quote.",
        },
        {
          icon: "mdi-history",
          title: "Quote History",
          body: "Ever wondered who updated/edited a quote? We will show you exactly who created the quote as well as who edited it, with the ability to store unlimited copies.",
        },
        {
          icon: "mdi-file-document-check-outline",
          title: "Compliance Document",
          body: "Generate a Compliance document that is easy to complete and send.",
        },
        {
          icon: "mdi-sort-clock-ascending-outline",
          title: "Saves time",
          body: "Medlogix allows medical brokers to generate new quotes for their clients quickly and efficiently, saving them valuable time.",
        },
        {
          icon: "mdi-cash-multiple",
          title: "No extra Cost",
          body: "Medlogix provides access to all providers and products with no additional cost, which means brokers can provide their clients with more options without increasing their workload.",
        },
      ],
      whatWeDo: [
        {
          image: require("../screenshots/One_Place.svg"),
          title: "Comprehensive Solution",
          body: "Medlogix offers a comprehensive solution to simplify your search for quotes. Gone are the days of spending countless hours searching through various sources to find the right quote that fits your needs. With our platform, you can easily access all the information you need in one convenient location.",
          imagePosition: "left",
        },
        {
          image: require("../screenshots/New_Product.svg"),
          title: "Regularly Updated",
          body: "We understand that staying up-to-date with the latest information and products is critical to providing the best quotes to your clients. That's why our website is updated regularly to ensure that you always have access to the most current and relevant information and products.",
          imagePosition: "right",
        },
        {
          image: require("../screenshots/Search_Products.svg"),
          title: "Search and Filter Products",
          body: "With Medlogix, you can easily search for products that you need and quickly access their information. Our user-friendly interface allows you to filter your search results based on different criteria, such as hospital benefits, chronic benefits, and day-to-day benefits. This makes it easy for you to find the products that are most relevant to your needs.",
          imagePosition: "left",
        },
        {
          image: require("../screenshots/All_In_One_Place.svg"),
          title: "Efficiently Manage Quotes",
          body: "Medlogix provides a simple and efficient way to manage your client's quotes, enabling you to create, edit, and track quotes for all your clients with ease. You no longer need to worry about keeping track of quotes in multiple places, as our platform allows you to manage all your client's quotes in one centralized location.",
          imagePosition: "right",
        }
      ],
      providersWeOfferArr: {
        'Providers': [
          'BestMed',
          'Bonitas',
          'Discovery',
          'FedHealth',
          'Medihelp',
          'MedShield',
          'Momentum',
          'Profmed'
        ],
        'Gap Covers': [
          'Sirago',
          'StratumBenefits',
        ]
      },
    }
  },
  methods: {
    async sendMessage() {
      if (!this.$refs.contact.validate())
        return
      this.sendingMail = true;

      try {
        (await Email.send({
          Host: "smtp.elasticemail.com",
          Username: "wernerd@tasklogix.co.za",
          Password: "B8336F9B1D8ED39EB1A634B41CF76120363D",
          To: ['wernerd@tasklogix.co.za', 'schalk@tasklogix.co.za', 'juan@tasklogix.co.za'],
          From: "wernerd@tasklogix.co.za",
          Subject: `${this.name} - Medlogix New Lead`,
          Body: `<html>
                <body>
                <p>Name and Surname: ${ this.name }</p>
                <p>Email: ${ this.email }</p>
                <p>${ this.message }</p>
                </body>
            </html>`
        }).then((message) => {
          alert(message);
        }).catch(e => {
          console.log(e);
          alert('Error Sending Mail');
        }))
      } catch (e) {
        console.log(e);
        alert('Error Sending Mail');
      }
      this.sendingMail = false;
    },
    changeColor() {
      if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        this.appBarColor = '#e3e2e2';
      } else {
        this.appBarColor = 'white';
      }
    },
  },
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
  }
};
</script>

<style scoped>
.gradiantText {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(145deg, rgba(251,101,66,1) 0%, rgba(255,187,0,1) 100%);
}

.animationLeftToRight {
  animation-name: lineLeftToRight;
  animation-duration: 300ms;
  border: 1px solid black
}
@keyframes lineLeftToRight {
  0% {
    width: 0;
  }
  25% {
    width: 25%;
  }
  75% {
    width: 75%;
  }
  100% {
    width: 85%;
  }
}
.animationRightToLeft {
  animation-name: lineRightToLeft;
  animation-duration: 250ms;
}
@keyframes lineRightToLeft {
  0% {
    width: 85%;
    border: 1px solid black;
  }
  25% {
    width: 75%;
    border: 1px solid black;
  }
  75% {
    width: 25%;
    border: 1px solid black;
  }
  100% {
    width: 0;
    border: 0 solid black;
  }
}

.gear-div {
  margin: 100px;
  width: 400px;
  height: 400px;
  position: relative;
}
.gear {
  animation: rotationFront 5s ease-in-out infinite;
}
.big-gear-div {
  position: absolute;
  width: 60%;
  height: 60%;
  left: 0;
  top: 0;
}
.small-gear-div {
  position: absolute;
  width: 48%;
  height: 48%;
  left: 39%;
  top: 39%
}
.small-gear {
  animation: rotationBack 5s ease-in-out infinite;
}
.gear-logo {
  position: absolute;
  width: 40%;
  height: 40%;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
@keyframes rotationFront {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-1turn);
  }
}
</style>